<template>
  <svg width="26" height="28" viewBox="0 0 26 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0.594454 0.500294C0.268066 0.833419 0.0791779 1.35207 0.0791779 2.02373V25.9817C0.0791779 26.6533 0.268066 27.172 0.594454 27.5051L0.675011 27.5782L14.4444 14.1584V13.8415L0.675011 0.421755L0.594454 0.500294Z" fill="url(#paint0_linear_1634_13)"/>
  <path d="M19.0291 18.6339L14.4444 14.1584V13.8415L19.0347 9.36601L19.1375 9.42424L24.5736 12.44C26.125 13.2958 26.125 14.7041 24.5736 15.5654L19.1375 18.5757L19.0291 18.6339V18.6339Z" fill="url(#paint1_linear_1634_13)"/>
  <path d="M19.1375 18.5757L14.4444 14L0.594444 27.5051C1.10972 28.0332 1.95 28.0969 2.90555 27.5687L19.1375 18.5757" fill="url(#paint2_linear_1634_13)"/>
  <path d="M19.1375 9.42426L2.90555 0.431237C1.95 -0.0914709 1.10972 -0.0278268 0.594444 0.500298L14.4444 14L19.1375 9.42426Z" fill="url(#paint3_linear_1634_13)"/>
  <defs>
  <linearGradient id="paint0_linear_1634_13" x1="13.2219" y1="26.2311" x2="-4.95322" y2="7.59002" gradientUnits="userSpaceOnUse">
  <stop stop-color="#00A0FF"/>
  <stop offset="0.0066" stop-color="#00A1FF"/>
  <stop offset="0.2601" stop-color="#00BEFF"/>
  <stop offset="0.5122" stop-color="#00D2FF"/>
  <stop offset="0.7604" stop-color="#00DFFF"/>
  <stop offset="1" stop-color="#00E3FF"/>
  </linearGradient>
  <linearGradient id="paint1_linear_1634_13" x1="26.5937" y1="13.9985" x2="-0.291695" y2="13.9985" gradientUnits="userSpaceOnUse">
  <stop stop-color="#FFE000"/>
  <stop offset="0.4087" stop-color="#FFBD00"/>
  <stop offset="0.7754" stop-color="#FFA500"/>
  <stop offset="1" stop-color="#FF9C00"/>
  </linearGradient>
  <linearGradient id="paint2_linear_1634_13" x1="16.5856" y1="11.5126" x2="-8.06137" y2="-13.7663" gradientUnits="userSpaceOnUse">
  <stop stop-color="#FF3A44"/>
  <stop offset="1" stop-color="#C31162"/>
  </linearGradient>
  <linearGradient id="paint3_linear_1634_13" x1="-2.89189" y1="35.4758" x2="8.11407" y2="24.1877" gradientUnits="userSpaceOnUse">
  <stop stop-color="#32A071"/>
  <stop offset="0.0685" stop-color="#2DA771"/>
  <stop offset="0.4762" stop-color="#15CF74"/>
  <stop offset="0.8009" stop-color="#06E775"/>
  <stop offset="1" stop-color="#00F076"/>
  </linearGradient>
  </defs>
  </svg>
</template>
<script>
  export default {
    name: 'PlayStoreIcon'
  }
</script>